import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarContribuinteDs,
  criarBairroDs,
  criarLogradouroDs,
} from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import showReport from "../../showReport";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import BairrosBox from "../BairrosBox";
import LogradourosBox from "../LogradourosBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";

const template = {
  id: undefined,
  prefeituraId: undefined,
  exercicio: new Date().getFullYear(),
  contribuinteId: undefined,
  bairroId: undefined,
  logradouroId: undefined,
  dataEmissão: undefined,
  parametro1: undefined,
  parametro2: undefined,
  imprimirVencidas: false,
  imprimirPagas: false,
  somenteBoletos: false,
  modelo: 0,
  tipoDeLancamento: 1,
  tipoParcela: 1,
  parametrosOptions: { mask: "", width: 50 },
  popupContribuinteVisivel: false,
  popupBairroVisivel: false,
  popupLogradouroVisivel: false,
  _uiNomeBairro: "IMPRIMIR PARA TODOS",
  _uiNomeContribuinte: "IMPRIMIR PARA TODOS",
  _uiNomeLogradouro: "IMPRIMIR PARA TODOS",
  tagsIds: ""

};

export default class ImprimirIptu extends React.Component {
  constructor(props) {
    super(props);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {};
    this.contribuinteDs = criarContribuinteDs();
    this.bairroDs = criarBairroDs();
    this.logradouroDs = criarLogradouroDs();

    this.onChange = this.onChange.bind(this);

    this.lancamentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: { id: 1, descricao: "Todos" },
      dataSource: [
        { id: 1, descricao: "Todos" },
        { id: 2, descricao: "Inscrição" },
        { id: 3, descricao: "Cartografia" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.onChange(e),
    };

    this.simNaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao"
    };

    this.modeloOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      noDataText: "Nenhum registo encontrado",
      placeholder: { id: 0, descricao: "1 Página" },
      dataSource: [
        { id: 0, descricao: "1 PÁGINA" },
        { id: 1, descricao: "1 PÁGINA COM MEMORIAL" },
        { id: 2, descricao: "FRENTE E VERSO" },
        { id: 3, descricao: "FRENTE E VERSO COM MEMORIAL" },
        { id: 4, descricao: "NOVO ORIENTE GRAFICA 2022" },
        { id: 5, descricao: "MEIA PÁGINA" },
        { id: 6, descricao: "NOVO ORIENTE - REENTREGA 2023" },
        { id: 7, descricao: "FRENTE E VERSO COM ARTE - SÃO BENEDITO 2024" },
        { id: 8, descricao: "NOVO ORIENTE GRAFICA 2025" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoParcelasOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "PADRÃO" },
        { id: 2, descricao: "PARCELAMENTO" },
        { id: 3, descricao: "COTA COM DESCONTO" },
        { id: 4, descricao: "COTA SEM DESCONTO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    /*
    // Syscode Contribuinte
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa = this.onContribuinteSelecionadoPesquisa.bind(
      this
    );
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    /*
    // Syscode Contribuinte End
    */
    /*
    // Syscode Bairro
    */
    this.setBairroId = this.setBairroId.bind(this);
    this.pesquisarBairro = this.pesquisarBairro.bind(this);
    this.onBairroSelecionadoPesquisa = this.onBairroSelecionadoPesquisa.bind(
      this
    );
    this.bairroBoxRef = React.createRef();
    this.renderBairro = sysCodigoDescricao(
      () => this.state.bairroId,
      this.setBairroId,
      () => this.state._uiNomeBairro,
      this.pesquisarBairro
    );
    this.atualizarNomeBairro = this.atualizarNomeBairro.bind(this);
    /*
   // Syscode Bairro End
   */
    /*
    // Syscode Logradouro
    */
    this.setLogradouroId = this.setLogradouroId.bind(this);
    this.pesquisarLogradouro = this.pesquisarLogradouro.bind(this);
    this.onLogradouroSelecionadoPesquisa = this.onLogradouroSelecionadoPesquisa.bind(
      this
    );
    this.logradouroBoxRef = React.createRef();
    this.renderLogradouro = sysCodigoDescricao(
      () => this.state.logradouroId,
      this.setLogradouroId,
      () => this.state._uiNomeLogradouro,
      this.pesquisarLogradouro
    );
    this.atualizarNomeLogradouro = this.atualizarNomeLogradouro.bind(this);
    /*
   // Syscode Logradouro End
   */
  }

  /*
  // Syscode Contribuinte Functions
  */

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({
        filter: [["sequencial", "=", this.state.contribuinteId]],
      })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setState({
            _uiNomeContribuinte: result[0].nome,
          });
        } else {
          this.setState({ _uiNomeContribuinte: "" });
        }
      })
      .catch((_) => this.setState({ _uiNomeContribuinte: "<<ERRO>>" }));
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      popupContribuinteVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }
  /*
  // Syscode Contribuinte Functions End
  */

  /*
  // Syscode Bairro Functions
  */

  setBairroId(data) {
    this.setState({ bairroId: data.value });
    this.atualizarNomeBairro();
  }

  atualizarNomeBairro() {
    this.bairroDs
      .load({
        filter: [["sequencial", "=", this.state.bairroId]],
      })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setState({
            _uiNomeBairro: result[0].descricao,
          });
        } else {
          this.setState({ _uiNomeBairro: "" });
        }
      })
      .catch((_) => this.setState({ _uiNomeBairro: "<<ERRO>>" }));
  }

  onBairroSelecionadoPesquisa(e) {
    this.setState({
      bairroId: e.row.data.sequencial,
      popupBairroVisivel: false,
    });
    this.atualizarNomeBairro();
  }

  pesquisarBairro() {
    //this.bairroBoxRef.current.limparFiltro();
    this.setState({ popupBairroVisivel: true });
  }
  /*
// Syscode Bairro Functions End
*/

  /*
  // Syscode Logradouro Functions
  */

  setLogradouroId(data) {
    this.setState({ logradouroId: data.value });
    this.atualizarNomeLogradouro();
  }

  atualizarNomeLogradouro() {
    this.logradouroDs
      .load({
        filter: [["sequencial", "=", this.state.logradouroId]],
      })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setState({
            _uiNomeLogradouro: result[0].nomeCompleto,
          });
        } else {
          this.setState({ _uiNomeLogradouro: "" });
        }
      })
      .catch((_) => this.setState({ _uiNomeLogradouro: "<<ERRO>>" }));
  }

  onLogradouroSelecionadoPesquisa(e) {
    this.setState({
      logradouroId: e.row.data.sequencial,
      popupLogradouroVisivel: false,
    });
    this.atualizarNomeLogradouro();
  }

  pesquisarLogradouro() {
    //this.logradouroBoxRef.current.limparFiltro();
    this.setState({ popupLogradouroVisivel: true });
  }
  /*
// Syscode Logradouro Functions End
*/

  onChange(e) {
    if (e.value === 1) {
      this.setState({ tipoDeLancamento: e.value });
    }
    if (e.value === 2) {
      this.setState({
        tipoDeLancamento: e.value,
        parametrosOptions: { mask: "", width: "100%" },
      });
    }
    if (e.value === 3) {
      this.setState({
        tipoDeLancamento: e.value,
        parametrosOptions: { mask: "00.00.000.0000.000", width: "100%" },
      });
    }
    if (e.value === "Data de Lançamento") {
      this.setState({
        tipoDeLancamento: e.value,
        parametrosOptions: { mask: "00/00/0000", width: 100 },
      });
    }
  }

  componentDidMount() {
    criarContribuinteDs()
      .load()
      .then((data) => {
        data.map((x) => {
          this.contribuinteDs.push(x);
        });
        console.log(data);
        console.log(this.contribuinteDs);
        console.log("tipo:", typeof data);
      });

    const currenteDate = new Date();
    const modelo = UserInfo.getPrefeitura() == 42 && currenteDate.getFullYear() == 2024 && UserInfo.possuiPerfil("trimap") ? 7 : 0;
    this.setState({ ...template, modelo});
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="IMPRESSÃO DE IPTU" colSpan={2} colCount={4}>
                <SimpleItem colSpan={1} dataField={"exercicio"}>
                  <Label text="Exercício" />
                </SimpleItem>
                <EmptyItem colSpan={3} />

                <SimpleItem colSpan={4} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem colSpan={4} component={this.renderBairro}>
                  <Label text="Bairro" />
                </SimpleItem>

                <SimpleItem colSpan={4} component={this.renderLogradouro}>
                  <Label text="Logradouro" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="Tipo do Lançamento" colSpan={2} colCount={1}>
                <SimpleItem
                  dataField={"tipoDeLancamento"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.lancamentoOptions}
                  colSpan={2}
                >
                  <Label text="Tipo de Lançamento" />
                </SimpleItem>

              </GroupItem>
              {this.state.tipoDeLancamento === 1 ? null : (
                <GroupItem caption="Parâmetros" colSpan={2} colCount={3}>
                  <SimpleItem
                    editorOptions={this.state.parametrosOptions}
                    colSpan={3}
                    dataField={"parametro1"}
                  >
                    <Label text="De" />
                  </SimpleItem>

                  <SimpleItem
                    editorOptions={this.state.parametrosOptions}
                    colSpan={3}
                    dataField={"parametro2"}
                  >
                    <Label text="Até" />
                  </SimpleItem>

                </GroupItem>
              )}
              <GroupItem colSpan={2} colCount={2}>
                <SimpleItem
                  dataField={"imprimirVencidas"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.simNaoOptions}
                >
                  <Label
                    text="Imprimir parcelas vencidas"
                  />
                </SimpleItem>
                <EmptyItem />
                <SimpleItem
                  dataField={"imprimirPagas"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.simNaoOptions}
                >
                  <Label
                    text="Imprimir parcelas pagas"
                  />
                </SimpleItem>
                <EmptyItem />
                <SimpleItem
                  dataField={"somenteBoletos"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.simNaoOptions}
                >
                  <Label
                    text="Somente boletos bancários"
                  />
                </SimpleItem>
                <EmptyItem />


                <SimpleItem
                  dataField={"modelo"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.modeloOptions}
                  colSpan={1}
                >
                  <Label text="Modelo" />
                </SimpleItem>
                <EmptyItem colSpan={3} />
                <SimpleItem
                  dataField={"tipoParcela"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoParcelasOptions}
                  colSpan={1}
                >
                  <Label text="Tipo Parcelas" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"tagsIds"}
                  colSpan={1}
                >
                  <Label text="TAGS IDS" />
                </SimpleItem>
              </GroupItem>


            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Protocolo"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Imprimir"
                  type="default"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Fechar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
        </div>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() => this.setState({ popupContribuinteVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinteVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupBairroVisivel}
          onHiding={() => this.setState({ popupBairroVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Bairro"
        >
          <ScrollView showScrollbar={"always"}>
            <BairrosBox
              onSelecionado={this.onBairroSelecionadoPesquisa}
              ref={this.bairroBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupBairroVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupLogradouroVisivel}
          onHiding={() => this.setState({ popupLogradouroVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Logradouro"
        >
          <ScrollView showScrollbar={"always"}>
            <LogradourosBox
              onSelecionado={this.onLogradouroSelecionadoPesquisa}
              ref={this.logradouroBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupLogradouroVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    var entidade = { ...this.state };
    showReport("/report/iptu", entidade);
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
